import { Installment, InstallmentOptions, Variant } from '../models/Item'
import constants from '../config/constants'

export const installmentsToInstallmentOptions = (
  installments: Installment[],
  variants: Variant[]
) => {
  let newObj: InstallmentOptions = {}

  variants.forEach((variant, index) => {
    newObj[variant.price] = [
      { length: 3, price: installments[index].month3 },
      { length: 6, price: installments[index].month6 }
    ]
  })

  return newObj
}

export const installmentOptionsToInstallments = (
  installmentOptions: InstallmentOptions
) => {
  let installments: Installment[] = []

  for (var key in installmentOptions) {
    installments.push({
      month3: installmentOptions[key][0].price,
      month6: installmentOptions[key][1].price
    })
  }

  return installments
}

export const isStraight = (installmentOptions: Installment[]): boolean => {
  let count = 0
  installmentOptions.forEach(installment => {
    if (installment.month3 === 0 && installment.month6 === 0) {
      count += 1
    }
  })

  if (count > 0) {
    return true
  } else {
    return false
  }
}

export const generateStraightPaymentObjects = (length: number) => {
  let straightArray: Installment[] = []
  for (var i = 0; i < length; i++) {
    straightArray.push(constants.straightPayment)
  }

  return straightArray
}
